/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './error-success-msg.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '../../../../../app/components/modals/error-success-msg/error-success-msg.component';
import * as i3 from 'ngx-bootstrap/modal/modal-options.class';
const styles_ErrorSuccessMsgComponent:any[] = [i0.styles];
export const RenderType_ErrorSuccessMsgComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_ErrorSuccessMsgComponent,data:{}});
export function View_ErrorSuccessMsgComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),4,'div',[['class',
      'modal-header text-center']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(2,
      0,(null as any),(null as any),1,'p',([] as any[]),(null as any),(null as any),
      (null as any),(null as any),(null as any))),(_l()(),i1.ɵted(3,(null as any),
      ['',''])),(_l()(),i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),
      ['\n'])),(_l()(),i1.ɵeld(6,0,(null as any),(null as any),4,'div',[['class','modal-footer'],
      ['style','text-align:center']],(null as any),(null as any),(null as any),(null as any),
      (null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n  '])),(_l()(),i1.ɵeld(8,
      0,(null as any),(null as any),1,'button',[['class','btn btn-default'],['data-dismiss',
          'modal'],['type','button']],(null as any),[[(null as any),'click']],(_v,
          en,$event) => {
        var ad:boolean = true;
        var _co:i2.ErrorSuccessMsgComponent = _v.component;
        if (('click' === en)) {
          const pd_0:any = ((<any>_co.confirmClose()) !== false);
          ad = (pd_0 && ad);
        }
        return ad;
      },(null as any),(null as any))),(_l()(),i1.ɵted(9,(null as any),['',''])),(_l()(),
      i1.ɵted(-1,(null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],
      (null as any),(_ck,_v) => {
        var _co:i2.ErrorSuccessMsgComponent = _v.component;
        const currVal_0:any = _co.srcObject.message;
        _ck(_v,3,0,currVal_0);
        const currVal_1:any = _co.srcObject.action2;
        _ck(_v,9,0,currVal_1);
      });
}
export function View_ErrorSuccessMsgComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),1,'app-error-success-msg',
      ([] as any[]),(null as any),(null as any),(null as any),View_ErrorSuccessMsgComponent_0,
      RenderType_ErrorSuccessMsgComponent)),i1.ɵdid(1,114688,(null as any),0,i2.ErrorSuccessMsgComponent,
      [i3.BsModalRef],(null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ErrorSuccessMsgComponentNgFactory:i1.ComponentFactory<i2.ErrorSuccessMsgComponent> = i1.ɵccf('app-error-success-msg',
    i2.ErrorSuccessMsgComponent,View_ErrorSuccessMsgComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvbW9kYWxzL2Vycm9yLXN1Y2Nlc3MtbXNnL2Vycm9yLXN1Y2Nlc3MtbXNnLmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL21vZGFscy9lcnJvci1zdWNjZXNzLW1zZy9lcnJvci1zdWNjZXNzLW1zZy5jb21wb25lbnQudHMiLCJuZzovLy9hcHAvc3JjL2FwcC9jb21wb25lbnRzL21vZGFscy9lcnJvci1zdWNjZXNzLW1zZy9lcnJvci1zdWNjZXNzLW1zZy5jb21wb25lbnQuaHRtbCIsIm5nOi8vL2FwcC9zcmMvYXBwL2NvbXBvbmVudHMvbW9kYWxzL2Vycm9yLXN1Y2Nlc3MtbXNnL2Vycm9yLXN1Y2Nlc3MtbXNnLmNvbXBvbmVudC50cy5FcnJvclN1Y2Nlc3NNc2dDb21wb25lbnRfSG9zdC5odG1sIl0sInNvdXJjZXNDb250ZW50IjpbIiAiLCI8ZGl2IGNsYXNzPVwibW9kYWwtaGVhZGVyIHRleHQtY2VudGVyXCI+XG4gIDxwID57e3NyY09iamVjdC5tZXNzYWdlfX08L3A+XG48L2Rpdj5cbjxkaXYgY2xhc3M9XCJtb2RhbC1mb290ZXJcIiBzdHlsZT1cInRleHQtYWxpZ246Y2VudGVyXCI+XG4gIDxidXR0b24gdHlwZT1cImJ1dHRvblwiIGNsYXNzPVwiYnRuIGJ0bi1kZWZhdWx0XCIgZGF0YS1kaXNtaXNzPVwibW9kYWxcIiAoY2xpY2spPVwiY29uZmlybUNsb3NlKClcIj57e3NyY09iamVjdC5hY3Rpb24yfX08L2J1dHRvbj5cbjwvZGl2PlxuIiwiPGFwcC1lcnJvci1zdWNjZXNzLW1zZz48L2FwcC1lcnJvci1zdWNjZXNzLW1zZz4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7O29CQ0FBO01BQUE7TUFBQSxnQkFBc0MsNENBQ3BDO01BQUE7TUFBQSw0Q0FBSTtNQUFBLFVBQXlCLDBDQUN6QjtNQUFBLFNBQ047TUFBQTtNQUFBLGdCQUFvRCw0Q0FDbEQ7TUFBQTtVQUFBO21CQUFBO1FBQUE7UUFBQTtRQUFtRTtVQUFBO1VBQUE7UUFBQTtRQUFuRTtNQUFBLGdDQUE0RiwwQ0FBOEI7YUFBQSwyQkFDdEg7OztRQUpBO1FBQUE7UUFHd0Y7UUFBQTs7OztvQkNKOUY7TUFBQTt5Q0FBQSxVQUFBO01BQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/modals/error-success-msg/error-success-msg.component.ngfactory.ts